export default __webpack_public_path__ + "static/media/acciones_pendientes2.38feab48.png";